import React, { useState } from "react";
import { resetPassword } from "../../redux/actions/authActions";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Form, Grid, Header, Image, Segment } from "semantic-ui-react";
function Reset() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(resetPassword(email));
  };

  return (
    <Grid
      textAlign="center"
      style={{ height: "79.5vh" }}
      verticalAlign="middle"
    >
      <Grid.Column
        style={{
          maxWidth: 450,
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        }}
      >
        <Header
          as="h2"
          color="blue"
          textAlign="center"
          style={{ paddingTop: "6px" }}
        >
          <Image
            src="https://firebasestorage.googleapis.com/v0/b/omnes-immigration.appspot.com/o/assets%2Fimages%2Ficon-set%2Ficon-america.png?alt=media&token=3a531c4a-5eff-43e5-a019-1d3c519cb18b"
            style={{ marginTop: "-6px", marginRight: "8px" }}
          />{" "}
          <span
            style={{
              color: "royalblue",
            }}
          >
            Send Password Reset Link
          </span>
        </Header>
        <Form size="large" onSubmit={handleSubmit}>
          <Segment stacked>
            <Form.Input
              id="email"
              fluid
              icon="user"
              iconPosition="left"
              placeholder="E-mail address"
              onChange={(e) => setEmail(e.target.value)}
            />

            <Form.Button
              style={{ backgroundColor: "royalblue", color: "white" }}
              fluid
              type="submit"
              size="large"
            >
              Send Link
            </Form.Button>
            <Link to="signin">Already have an account? Login.</Link>
          </Segment>
        </Form>
      </Grid.Column>
    </Grid>
  );
}

export default Reset;
